module.exports = __webpack_public_path__ + "static/media/20_tn.09dddb9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/20_tn.jpg
// module id = 656
// module chunks = 0